import { getProperty } from '@ozgene/gp5.utils.object-functions';

export const getUniqueArray = (array) => [...new Set(array)];

export const getUniqueKeys = (objectArray, objectKey) =>
  getUniqueArray(objectArray.map((o) => getProperty(o, objectKey)));

export const getUniqueObjectsByKey = (objectArray, objectKey) => [
  ...new Map(objectArray.map((o) => [getProperty(o, objectKey), o])).values(),
];

export const convertToObjectByKey = (objectArray, objectKey, valueKey) =>
  Object.fromEntries(
    objectArray.map((o) => [
      getProperty(o, objectKey),
      valueKey ? getProperty(o, valueKey) : o,
    ])
  );

export const toggleArrayInclusion = (array, object) => {
  const set = new Set(array);

  return [...(set.delete(object) ? set : set.add(object))];
};

export const convertToArrayOfObjects = (object, indexKey, valueKey) =>
  Object.entries(object).map(([key, value]) => ({
    [indexKey]: key,
    [valueKey]: value,
  }));

export const equalArrays = (a, b) =>
  a.length === b.length && a.every((eA, i) => eA === b[i]);

export const getUniqueArrayGroupedByKey = (objectArray, objectKey, valueKey) =>
  objectArray.reduce(
    (result, o) =>
      Object.assign(result, {
        [getProperty(o, objectKey)]: [
          ...new Set(result[getProperty(o, objectKey)] || []).add(
            valueKey ? getProperty(o, valueKey) : o
          ),
        ],
      }),
    {}
  );
export const removeFromUniqueArray = (array, object) => {
  const set = new Set(array);

  set.delete(object);

  return [...set];
};

/**
 * Remove provided objects (by reference) from the array of unique objects
 * 
 * @param {Object[]} uniqueArray Array of unique objects
 * @param {Object[]} objectsToRemove Array of objects to remove (by reference)
 * @returns 
 */
export const removeAllFromUniqueArray = (uniqueArray, objectsToRemove) => {
  const set = new Set(uniqueArray);

  for (const object of objectsToRemove) {
    set.delete(object);
  }

  return [...set];
};
